import jsx from './jsx';
import { makeApiRequest, skeleton } from './utils';

interface UptimeData {
  time: string;
  status: 'UP' | 'DOWN' | 'UNKNOWN';
}

const prettyStatus = {
  UP: 'Up',
  DOWN: 'Offline',
  UNKNOWN: 'Unknown',
};

document.addEventListener('DOMContentLoaded', async () => {
  const renderTarget = document.getElementsByClassName('uptime')?.[0];
  renderTarget?.append(skeleton('100%', '500px'));

  const json = await makeApiRequest<Record<string, UptimeData[]>>(
    '/uptime',
    'GET',
  );

  if (renderTarget && json) {
    renderTarget.innerHTML = '';

    renderTarget.append(
      ...Object.keys(json).map((service) => {
        const serviceData = json[service];
        const recentStatus = serviceData[serviceData.length - 1].status;
        const recentTime = serviceData[serviceData.length - 1].time;
        const dateAsLocaleString = new Date(recentTime).toLocaleString();

        return (
          <div>
            <h2>{service}</h2>
            <p>
              Service was <b>{prettyStatus[recentStatus]}</b> at{' '}
              {dateAsLocaleString}
            </p>
            <div className="dataWrapper">
              {...serviceData.map((data) => (
                <div
                  className={`data ${data.status}`}
                  title={`${data.status}: ${new Date(data.time).toLocaleString()}`}
                />
              ))}
            </div>
          </div>
        );
      }),
    );
  }
});
